import { type Event, MessageBus } from '@podium/browser';
import { useCallback, useEffect, useState } from 'react';

export function useSearchParams(): URLSearchParams {
    const [searchParams, setSearchParams] = useState<URLSearchParams>(
        () => new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search),
    );

    const callback = useCallback((event: Event) => {
        setSearchParams(createQueryString(event.payload as object));
    }, []);

    useEffect(() => {
        const bus = new MessageBus();
        bus.subscribe('filter', 'updated', callback);
        return () => {
            bus.unsubscribe('filter', 'updated', callback);
        };
    }, [callback]);

    return searchParams;
}

function createQueryString(queryParams: object): URLSearchParams {
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                searchParams.append(key, item);
            });
        } else {
            searchParams.append(key, value);
        }
    });
    return searchParams;
}
